import React from 'react';
import PropTypes from 'prop-types';
import { CONVERTTIME, TIMETOAMPM } from '../../../../utils/dateController';

const getNumberOfSpots = (programData) => {
  if (programData.weeklyProgram && programData.weeklySchedule && programData.weeklySchedule.length > 0) {
    let result = 0;
    programData.weeklySchedule.forEach((week) => {
      result += ((week.associateSpots || 0) + (week.communitySpots || 0) - (week.familyMembers ? week.familyMembers.length : 0));
    });
    return result;
  }
  if (programData.associateSpots != null || programData.communitySpots != null) {
    return (programData.associateSpots || 0) + (programData.communitySpots || 0);
  }
  return programData.numberOfSpots || 0;
};

export default function ProgramsLisTableExport({
  data,
  sortSeason,
  sortSearch,
  sortAges,
}) {
  const filteredData = React.useMemo(() => {
    return data.filter((row) => {
      // 1. Search filter
      const searchMatch = !sortSearch || (row.name || '').toLowerCase().includes((sortSearch || '').toLowerCase());

      // 2. Age filter
      const ageArray = Array.isArray(sortAges) ? sortAges : (sortAges ? [sortAges] : []);
      const ageMatch = ageArray.length === 0 || ageArray.some((age) => (row.ages || '').toLowerCase() === (age || '').toLowerCase());

      // 3. Season filter
      const seasonArray = Array.isArray(sortSeason) ? sortSeason : (sortSeason ? [sortSeason] : []);
      const seasonMatch = seasonArray.length === 0 || (row.seasons && (
        Array.isArray(row.seasons)
          ? row.seasons.some((s) => seasonArray.some((filterSeason) => (s || '').toLowerCase().includes((filterSeason || '').toLowerCase())))
          : seasonArray.some((filterSeason) => (row.seasons || '').toLowerCase().includes((filterSeason || '').toLowerCase()))
      ));

      return searchMatch && ageMatch && seasonMatch;
    });
  }, [data, sortSearch, sortAges, sortSeason]);

  return (
    <div>
      <table className="table">
        <thead>
          <tr>
            <th scope="col">Program Name</th>
            <th scope="col">Ages</th>
            <th scope="col">Season</th>
            <th scope="col">Days</th>
            <th scope="col">Time</th>
            <th scope="col">Duration</th>
            <th scope="col">Spots Left</th>
          </tr>
        </thead>
        <tbody>
          {filteredData.map((row, index) => {
            const duration = `${CONVERTTIME(row.durationStartDate, false)} - ${CONVERTTIME(row.durationEndDate, false)}`;
            const days = row.days && row.days.map((i) => i.substring(0, 3)).toString().replace(/,/g, '-');
            const time = `${TIMETOAMPM(row.programStartTime)} - ${TIMETOAMPM(row.programEndTime)}`;
            const seasonStr = Array.isArray(row.seasons) ? row.seasons.join(', ') : (row.seasons || '');

            return (
              <tr key={index}>
                <td>{row.name}</td>
                <td>{row.ages}</td>
                <td>{seasonStr}</td>
                <td>{days}</td>
                <td>{time}</td>
                <td>{duration}</td>
                <td>{getNumberOfSpots(row)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

ProgramsLisTableExport.propTypes = {
  data: PropTypes.arrayOf(PropTypes.any).isRequired,
  sortSeason: PropTypes.arrayOf(PropTypes.string).isRequired,
  sortAges: PropTypes.arrayOf(PropTypes.string).isRequired,
  sortSearch: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]).isRequired,
};